// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".usage-metric-chart[data-v-7c353c86] .z-chart-wrapper{--vis-axis-domain-color:#33cb9a;--vis-dark-axis-domain-color:#33cb9a;--vis-axis-tick-color:transparent;--vis-dark-axis-tick-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
